import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { useState } from "react"
import { useSwitchActiveMembershipMutation } from "../services/activeMembershipApi"
import { useAppSelector } from "../store/hooks"
import { selectActiveOrgId, selectUser } from "../store/sessionSlice"

export function OrgSelector() {
  const user = useAppSelector(selectUser)
  const activeOrgId = useAppSelector(selectActiveOrgId)
  const [switchActiveMembership] = useSwitchActiveMembershipMutation()
  const [isSwitchingOrg, setIsSwitchingOrg] = useState(false)

  if (!user?.cross_org.length) {
    return null
  }

  const handleChange = async (event: SelectChangeEvent<string>) => {
    const selectedOrgId = event.target.value
    setIsSwitchingOrg(true)

    try {
      await switchActiveMembership(selectedOrgId).unwrap()
      // Invalidate all queries when org changes
      window.location.reload()
    } finally {
      setIsSwitchingOrg(false)
    }
  }

  return (
    <FormControl variant="standard">
      <Select
        value={activeOrgId}
        displayEmpty
        disableUnderline
        disabled={isSwitchingOrg}
        onChange={(event) => {
          void handleChange(event)
        }}
        sx={{
          color: "inherit",
          minWidth: 200,
          "& .MuiSelect-icon": {
            color: "inherit",
          },
        }}
      >
        {user.cross_org.map((org) => (
          <MenuItem key={org.id} value={org.id}>
            {org.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
